import weaponsSkills from './img/weapons.png';
import healing       from './img/healing.png';
import utilitySkills from './img/utility.png';
import eliteSkill    from './img/elite.png';
import profSkills    from './img/prof.png';
import energy        from './img/energy.png';
import health        from './img/health.png';
import swap          from './img/swap.png';
import effects       from './img/effects.png';
import mount         from './img/mount.png';

const prefix = 'part1.c.sb';

const info = {
    weapons : {
        header : `${prefix}.slots`,
        label  : `${prefix}.weapon.header`,
        img    : weaponsSkills,
        slots  : [ 1, 5 ],
        area   : {
            shape  : 'rect',
            coords : '50,68,386,138'
        },
        svg : {
            x      : 49.12,
            y      : 66.41,
            width  : 338.82,
            height : 72.47
        }
    },
    energy : {
        label : `${prefix}.energy.header`,
        img   : energy,
        area  : {
            shape  : 'poly',
            coords : '381,49,393,29,418,11,448,5,480,13,499,26,516,49,507,56,487,33,465,20,433,18,407,32,391,53'
        },
        svg : {
            d : 'M392.56,54.35A61.77,61.77,0,0,1,505.92,56l10.5-4.24a73.09,73.09,0,0,0-134.36-1.63Z'
        }
    },
    healing : {
        header : `${prefix}.slot`,
        label  : `${prefix}.healing.header`,
        img    : healing,
        slots  : [ 6 ],
        area   : {
            shape  : 'rect',
            coords : '510,67,578,137'
        },
        svg : {
            x      : 509.82,
            y      : 66.41,
            width  : 67.12,
            height : 72.47
        }
    },
    health : {
        label : `${prefix}.health.header`,
        img   : health,
        area  : {
            shape  : 'circle',
            coords : '448,81,62'
        },
        svg : {
            cx : 448.5,
            cy : 80,
            r  : 61.59
        }
    },
    utility : {
        header : `${prefix}.slots`,
        label  : `${prefix}.utility.header`,
        img    : utilitySkills,
        slots  : [ 7, 9 ],
        area   : {
            shape  : 'rect',
            coords : '578,70,781,138'
        },
        svg : {
            x      : 577.82,
            y      : 66.41,
            width  : 202.12,
            height : 72.47
        }
    },
    swap : {
        label : `${prefix}.swap.header`,
        img   : swap,
        area  : {
            shape  : 'rect',
            coords : '0,69,49,120'
        },
        svg : {
            x      : 0,
            y      : 68.76,
            width  : 49.12,
            height : 51.76
        }
    },
    elite : {
        header : `${prefix}.slot`,
        label  : `${prefix}.elite.header`,
        img    : eliteSkill,
        slots  : [ 0 ],
        area   : {
            shape  : 'rect',
            coords : '780,68,848,138'
        },
        svg : {
            x      : 780.82,
            y      : 66.41,
            width  : 67.12,
            height : 72.47
        }
    },
    effects : {
        label : `${prefix}.effects.header`,
        img   : effects,
        area  : {
            shape  : 'rect',
            coords : '526,8,606,46'
        },
        svg : {
            x      : 526.29,
            y      : 6.62,
            width  : 80,
            height : 39.56
        }
    },
    prof : {
        label : `${prefix}.prof.header`,
        img   : profSkills,
        slots : [ 'F1', 'F4' ],
        area  : {
            shape  : 'rect',
            coords : '55,0,238,62'
        },
        svg : {
            x      : 54.76,
            y      : 0,
            width  : 182.59,
            height : 61.71
        }
    },
    mount : {
        label : `${prefix}.mount.header`,
        img   : mount,
        area  : {
            shape  : 'rect',
            coords : '849,68,900,117'
        },
        svg : {
            x      : 851,
            y      : 67.76,
            width  : 49.12,
            height : 51.76
        }
    }
};


export default {
    info,
    keys : Object.keys(info)
};
